module.exports = __webpack_public_path__ + "static/img/prof_dev.6a223e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prof_dev.jpg
// module id = o+kJ
// module chunks = 1